import { Box, CircularProgress, Button, TextField, Stack } from "@mui/material";
import { useState, useEffect } from "react";

const MobileViewTabelList = (props) => {
  const [search, setSearch] = useState(props?.globalFilter || "");
  useEffect(() => {
    const timer = setTimeout(() => {
      props?.setPagination((prev) => ({ ...prev, pageIndex: 0 }));
      props?.setGlobalFilter(search);
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [search]);
  return (
    <>
      {!props?.noPagination && (
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            size="small"
            label={`Search ${props?.searchLabel}`}
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
      )}
      {props?.loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "250px",
            gap: 1,
          }}
        >
          <CircularProgress size={30} />
          <span style={{ fontSize: 13, color: "#666" }}>
            Loading {props?.searchLabel}...
          </span>
        </Box>
      ) : (
        props?.children
      )}
      {!props?.noPagination && (
        <>
          <Stack direction="row" spacing={1} mt={2}>
            <Button
              fullWidth
              variant="outlined"
              disabled={props?.pagination.pageIndex === 0}
              onClick={() =>
                props?.setPagination((prev) => ({
                  ...prev,
                  pageIndex: prev.pageIndex - 1,
                }))
              }
            >
              Prev
            </Button>
            <Button
              fullWidth
              variant="outlined"
              disabled={
                (props?.pagination.pageIndex + 1) *
                  props?.pagination.pageSize >=
                props?.totalResults
              }
              onClick={() =>
                props?.setPagination((prev) => ({
                  ...prev,
                  pageIndex: prev.pageIndex + 1,
                }))
              }
            >
              Next
            </Button>
          </Stack>
          <Box textAlign="center" mt={4} mb={4} fontSize={12} color="#666">
            Page {props?.pagination.pageIndex + 1} of{" "}
            {Math.ceil(props?.totalResults / props?.pagination.pageSize)}
          </Box>
        </>
      )}
    </>
  );
};

export default MobileViewTabelList;